import WorldIcon from 'components/ReusableComponents/Icons/World'
import { useSelector } from 'react-redux'

const HeaderChecklist = () => {
  const isGdsBookingAvailable = useSelector(s => s.hotelDetails.isGdsBookingAvailable)

  return (
    <>
      <WorldIcon
        fill={isGdsBookingAvailable ? '#66bb6a' : '#b7babf'}
        width="27px"
        height="27px"
        style={{ position: 'releative', top: '0', marginRight: 12 }}
        title="GDS Booking is available"
      />
    </>
  )
}

export default HeaderChecklist
